const locale = {
  TITLE_TIMEOUT: 'Algo salió mal de nuestro lado',
  SUBTITLE_TIMEOUT:
    'Nuestros servidores tuvieron un problema inesperado. Ya estamos trabajando en ello, esto suele resolverse en unos minutos.',
  RETRY_BUTTON_TIMEOUT: 'Intentar nuevamente',
};

export default locale;
